

































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  calculationMonth(date: string): number {
    if (date) {
      return Math.abs(moment().diff(moment(date), "months"));
    }
    return 0;
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                // console.log(key)
                // console.log(fieldValue._f)
                if (moment.isMoment(fieldValue)) {
                  if (_.has(fieldValue, ["_f"])) {
                    _.set(values, [key], moment(fieldValue).format(_.get(fieldValue, ["_f"])));
                  } else {
                    _.set(values, [key], moment(fieldValue).format("YYYY-MM-DD HH:mm:ss"));
                  }
                } else {
                  _.set(values, [key], fieldValue);
                }
              }
            }
            const res = await this.$store.dispatch("enterapply/savedetail", {
              stadium_id: this.stadiumId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("enterapply/detail", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data != "{}") {
      this.formData = res.Data;
      this.form.setFieldsValue({
        stadium_type: res.Data.stadium_type
      });
    }
    this.spinLoading = false;
  }
}
